import {
  RoomRegularlyReservation,
  convertToRoomRegularlyReservation
} from "@/entities/room_regularly_reservation";
import firebase from "firebase/app";

export async function getRoomReservations(): Promise<
  RoomRegularlyReservation[]
> {
  try {
    const snapshot = await firebase
      .firestore()
      .collection("roomRegularlyReservationsOfPopy")
      .get();
    return snapshot.docs.map(d =>
      convertToRoomRegularlyReservation(d.data(), d.ref)
    );
  } catch (e) {
    return [];
  }
}

export type WaitingStudent = {
  ref: firebase.firestore.DocumentReference;
  data: WaitingStudentData;
};

type WaitingStudentData = {
  mtelHost: string;
  startOn: number;
  endOn: number;
  studentId: string;
  classroomId: string;
  schoolId: string;
  goal: string;
  gradeText: string;
  displayName: string;
  subjectsText: string;
};

export async function getWaitingStudents(
  reservationId: string
): Promise<WaitingStudent[]> {
  try {
    const snapshot = await firebase
      .firestore()
      .collection("roomRegularlyReservationsOfPopy")
      .doc(reservationId)
      .collection("waitingStudents")
      .get();
    if (snapshot.empty) {
      return [];
    }
    return snapshot.docs.map(d => {
      const {
        mtelHost,
        startOn,
        endOn,
        studentId,
        classroomId,
        schoolId,
        goal,
        gradeText,
        displayName,
        subjectsText
      } = d.data();
      return {
        ref: d.ref,
        data: {
          mtelHost,
          startOn,
          endOn,
          studentId,
          classroomId,
          schoolId,
          goal,
          gradeText,
          displayName,
          subjectsText
        }
      };
    });
  } catch (e) {
    return [];
  }
}

export async function postWaitingData(
  reservationId: string,
  data: WaitingStudentData
): Promise<string> {
  try {
    const snapshot = await firebase
      .firestore()
      .collection("roomRegularlyReservationsOfPopy")
      .doc(reservationId)
      .get();
    const _data = snapshot.data();
    if (!snapshot.exists || !_data) {
      return "";
    }
    const newRef = snapshot.ref.collection("waitingStudents").doc();
    newRef.set(data);
    return newRef.id;
  } catch (e) {
    console.log(e);
    return "";
  }
}
